// @flow
import React from 'react';

type Props = {
	match: Object
}

const Players = (props: Props) => {
	const { match } = props;
	return (
		<div>
			<h1>Player - PlayerId {match.params.playerId}</h1>
		</div>
	);
};

export default Players;


// WEBPACK FOOTER //
// ./src/pages/league/Player.js